import { Button, Dialog, IconButton } from '@nrg/design-system';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LuBell } from 'react-icons/lu';
import { useNotifications } from '@/modules/topbar/data/useNotifications';
import styles from './NotificationButton.module.css';
import { NotificationList } from './NotificationList';

const MAX_BADGE_COUNT = 9;

export function NotificationButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { items, unreadCount, markAllRead, isLoading } = useNotifications();

  const badge =
    unreadCount > 0 ? (
      <span>{unreadCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : unreadCount}</span>
    ) : undefined;

  return (
    <Dialog.Root open={open} onOpenChange={(detail) => setOpen(detail.open)}>
      <Dialog.Trigger asChild>
        <IconButton
          label={t('topbar.notifications.label', { count: unreadCount })}
          variant="secondary"
          {...(badge !== undefined && { badge })}
        >
          <LuBell aria-hidden="true" />
        </IconButton>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner placement="top">
          <Dialog.Content size="md" placement="top">
            <Dialog.Header>
              <Dialog.Title>{t('topbar.notifications.title')}</Dialog.Title>
              <p className={styles.subtitle}>{t('topbar.notifications.subtitle')}</p>
            </Dialog.Header>
            <Dialog.Body scrollable>
              {/* Without the gate the in-flight list reads as "all caught up". */}
              {isLoading ? (
                <p className={styles.status} role="status">
                  {t('loading')}
                </p>
              ) : (
                <NotificationList items={items} onSelect={() => setOpen(false)} />
              )}
            </Dialog.Body>
            {items.length > 0 && (
              <Dialog.Footer bordered>
                <Button variant="secondary" size="sm" onClick={() => markAllRead()}>
                  {t('topbar.notifications.markAllRead')}
                </Button>
              </Dialog.Footer>
            )}
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
